var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.676 8.34904H3.00932C2.08884 8.34904 1.34265 9.09524 1.34265 10.0157V15.849C1.34265 16.7695 2.08884 17.5157 3.00932 17.5157H14.676C15.5965 17.5157 16.3427 16.7695 16.3427 15.849V10.0157C16.3427 9.09524 15.5965 8.34904 14.676 8.34904Z",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67596 8.34904V5.01571C4.67596 3.91064 5.11495 2.85083 5.89635 2.06943C6.67775 1.28803 7.73756 0.849045 8.84263 0.849045C9.9477 0.849045 11.0075 1.28803 11.7889 2.06943C12.5703 2.85083 13.0093 3.91064 13.0093 5.01571V8.34904",
    stroke: "#848484",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.95fac6dedd149fe7973d5405d0d59c1b.svg";
export { ForwardRef as ReactComponent };